import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectCurrentUserEmployerProjects } from 'store/resources/selectors/resources.selectors';
import { patchUpdateActiveEmployer } from '../services/patchUpdateActiveEmployer.service';

export const updateUserActiveEmployer = createAsyncThunk(
  'user/updateUserActiveEmployer',
  async (
    { activeEmployerId, history, navigateToEmployer = false },
    { getState }
  ) => {
    const userSetting = await patchUpdateActiveEmployer({ activeEmployerId });

    const employerProjects = selectCurrentUserEmployerProjects(getState());

    const selectedActiveEmployerProject = employerProjects.find(
      (employer) => employer.id === activeEmployerId
    );

    if (navigateToEmployer) {
      if (activeEmployerId === 'myLixani') {
        history.push(`/projects`);
      } else {
        history.replace(`/project/${selectedActiveEmployerProject.projectKey}`);
      }
    }

    return userSetting;
  }
);
